import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { PlusIcon, TrashIcon } from '@phosphor-icons/react';

import { ConfirmDialog } from '../../../../components/dialog/ConfirmDialog';
import { ITableHeader, Table } from '../../../../components/table/Table';
import { deleteCustomerContacts } from '../../models';
import { getDisplayError } from '../../../../utils/get-display-error';
import { formatPhoneNumber } from '../../../../utils/phonenumber';
import { useCustomer } from '../Customer/customerContext';
import { LinkButton } from '../../../../components/button/ButtonLink';
import { captureException } from '@sentry/react';

const CONTACT_HEADERS: ITableHeader[] = [
  {
    id: 'name',
    name: 'Naam',
  },
  {
    id: 'email',
    name: 'Email',
  },
  {
    id: 'phone',
    name: 'Telefoon',
  },
  {
    id: 'function',
    name: 'Functie',
  },
  {
    id: 'language',
    name: 'Taal',
  },
  {
    id: 'notifications',
    name: 'Contact geschikt voor',
  },
  {
    id: 'delete',
    name: 'Verwijder',
  },
];

export const CustomerContacts = () => {
  const { customer, refreshData } = useCustomer();

  const refresh = useCallback(() => {
    refreshData();
  }, [refreshData]);

  return (
    <div>
      <div className="flex justify-end mb-4">
        <LinkButton to="new" color="primary" iconLeft={<PlusIcon className="button-icon" />}>
          Nieuw contact
        </LinkButton>
      </div>

      <Table
        idKey="id"
        headers={CONTACT_HEADERS}
        data={customer.contacts}
        mapData={(data) => {
          const notifications = [];
          if (data.shouldReceiveInvoices) {
            notifications.push('Facturatie');
          }
          if (data.shouldReceiveOrderConfirmations) {
            notifications.push('Order bevestiging');
          }
          if (data.shouldReceiveCMR) {
            notifications.push('CMR');
          }
          if (data.shouldReceiveQuotations) {
            notifications.push('Offertes');
          }
          if (data.shouldReceiveDieselSurcharge) {
            notifications.push('Dieseltoeslag');
          }
          if (data.shouldReceivePaymentReminder) {
            notifications.push('Betaalherinnering');
          }
          return [
            <Link to={`${data.id}`} className="link-text">
              {data.name}
            </Link>,
            data.email,
            formatPhoneNumber(data.phone, true),
            data.function,
            data.language,
            notifications.join(', '),
            <ConfirmDialog
              triggerColor="danger"
              triggerText={<TrashIcon className="button-icon" />}
              title="Verwijder contacten"
              submitText="Verwijder"
              description={`Ben je zeker dat je contact ${data.name} wilt wissen?`}
              onSubmit={async () => {
                try {
                  await deleteCustomerContacts(customer.id, [data.id]);
                  refresh();
                } catch (err) {
                  captureException(err);
                  toast.error('Kon contact niet verwijderen: ' + getDisplayError(err));
                }
              }}
            />,
          ];
        }}
      />
    </div>
  );
};
